"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _constants = require("../../constants");

var _lib = require("../../lib");

require("./styles.css");

var _Button = _interopRequireDefault(require("../Button"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _PreSuffix = _interopRequireDefault(require("../PreSuffix"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var InputBase =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InputBase, _PureComponent);

  function InputBase(props) {
    var _this;

    _classCallCheck(this, InputBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputBase).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getType", function (check) {
      var type = _this.props.type; // return 'text' if type is not one of the allowed types

      if (_constants.INPUT_TYPES.some(function (t) {
        return t === type;
      })) {
        return check ? check === type : type;
      }

      return check ? check === 'text' : 'text';
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (e) {
      var value = (0, _lib.getEventKey)(e);
      return _this.getType('number') ? InputBase.getValueAsNumber(value) : value;
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [InputBase.className];
      (0, _lib.addClassByPropName)(names, _this.props);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
      if (e && e.persist) e.persist();
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          onClick = _this$props.onClick,
          name = _this$props.name;

      if (disabled || readOnly) {
        if (e && e.preventDefault) e.preventDefault();
        return;
      }

      var value = _this.state.value;

      if (onClick) {
        onClick(e, {
          name: name,
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var value = _this.getValue(e);

      _this.setState({
        value: value
      }, function () {
        var _this$props2 = _this.props,
            onChange = _this$props2.onChange,
            name = _this$props2.name;

        if (onChange) {
          onChange(e, {
            name: name,
            value: value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          onFocus = _this$props3.onFocus,
          name = _this$props3.name;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var value = _this.state.value;

      if (onFocus) {
        onFocus(e, {
          name: name,
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          onBlur = _this$props4.onBlur,
          name = _this$props4.name;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var value = _this.state.value;

      if (onBlur) {
        onBlur(e, {
          name: name,
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleShowPassword", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      _this.setState(function (prevState) {
        return {
          passwordMasked: !prevState.passwordMasked
        };
      });
    });

    var _value = props.value,
        _type = props.type,
        defaultValue = props.defaultValue;
    var newValue = _type === 'number' ? InputBase.getValueAsNumber(_value) : _value;
    _this.state = {
      prevProps: {
        value: _value
      },
      // this only store props.value
      value: newValue || defaultValue,
      passwordMasked: true
    };
    return _this;
  }

  _createClass(InputBase, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          value = _this$props5.value,
          defaultValue = _this$props5.defaultValue,
          type = _this$props5.type,
          className = _this$props5.className,
          onChange = _this$props5.onChange,
          onFocus = _this$props5.onFocus,
          onBlur = _this$props5.onBlur,
          innerRef = _this$props5.innerRef,
          rest = _objectWithoutProperties(_this$props5, ["value", "defaultValue", "type", "className", "onChange", "onFocus", "onBlur", "innerRef"]);

      var passwordMasked = this.state.passwordMasked;
      var inputType = this.getType();
      var classNames = this.classNames();
      return _react["default"].createElement(_PreSuffix["default"], {
        suffix: inputType === 'password' ? _react["default"].createElement(_Button["default"], {
          tabIndex: -1,
          className: "show-password-icon",
          basic: true,
          icon: passwordMasked ? _react["default"].createElement(_Icon["default"].Hide, null) : _react["default"].createElement(_Icon["default"].View, null),
          onClick: this.handleToggleShowPassword
        }) : null
      }, _react["default"].createElement("input", _extends({}, rest, {
        ref: innerRef,
        className: classNames,
        type: inputType === 'password' && !passwordMasked ? 'text' : inputType,
        value: inputType !== 'password' ? this.state.value : undefined,
        onChange: this.handleOnChange,
        onFocus: this.handleOnFocus,
        onBlur: this.handleOnBlur,
        onClick: this.handleOnClick
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          type = props.type;
      var newValue = type === 'number' ? InputBase.getValueAsNumber(value) : value;
      return {
        // Store the previous props in state
        prevProps: {
          value: value
        },
        value: prevProps.value !== value ? newValue : state.value
      };
    } // getter

  }, {
    key: "getValueAsNumber",
    value: function getValueAsNumber(value) {
      if (value) {
        return Math.round(value * 100) / 100;
      }

      return 0;
    }
  }]);

  return InputBase;
}(_react.PureComponent);

exports["default"] = InputBase;

_defineProperty(InputBase, "className", 'MHub-Input-Base');

_defineProperty(InputBase, "displayName", 'InputBase');

_defineProperty(InputBase, "propTypes", {
  value: _common.customPropTypes.stringOrNumber,
  defaultValue: _common.customPropTypes.stringOrNumber,
  name: _propTypes["default"].string,
  className: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(_constants.INPUT_TYPES),
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  readOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  innerRef: _common.customPropTypes.ref
});

_defineProperty(InputBase, "defaultProps", {
  value: undefined,
  defaultValue: '',
  name: null,
  type: 'text',
  className: null,
  onChange: null,
  onClick: null,
  onFocus: null,
  onBlur: null,
  readOnly: false,
  disabled: false,
  maxLength: null,
  innerRef: null
});